import { render, staticRenderFns } from "./FreightRatePage.vue?vue&type=template&id=2148cfb6&scoped=true"
import script from "./FreightRatePage.vue?vue&type=script&lang=js"
export * from "./FreightRatePage.vue?vue&type=script&lang=js"
import style0 from "./FreightRatePage.vue?vue&type=style&index=0&id=2148cfb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2148cfb6",
  null
  
)

export default component.exports